import { render, staticRenderFns } from "./GroupScheduleExamCards.vue?vue&type=template&id=1a0e0982&"
import script from "./GroupScheduleExamCards.vue?vue&type=script&lang=js&"
export * from "./GroupScheduleExamCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports